import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { WheelAlignmentInfoLightBoxHeader } from './wheel_alignment_info_light_box_header';
import { WheelAlignmentInfoLightBoxContent } from './wheel_alignment_info_light_box_content';

function WheelAlignmentInfoLightBox(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['wheel-alignment-info-light-box__lightbox']}
            headerIcon="icon--wheel-alignment"

        >
            <div className="wheel-alignment-info-light-box">
                <WheelAlignmentInfoLightBoxHeader />
                <WheelAlignmentInfoLightBoxContent
                    expanded={props.expanded}
                    FSFLightBoxVisible={props.FSFLightBoxVisible}
                    detailModeStation={props.detailModeStation}
                    activeStation={props.activeStation}
                    onExpand={props.onExpand}
                    onRemove={props.onRemove}
                    onAccept={props.onAccept}
                    onClose={props.onClose}
                />
            </div>
        </Lightbox>
    );
}

WheelAlignmentInfoLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    FSFLightBoxVisible: PropTypes.bool.isRequired,
    detailModeStation: PropTypes.string,
    activeStation: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { WheelAlignmentInfoLightBox };
